import React, {useEffect, useMemo, useState} from 'react';
import {MenuItem, Select, Typography} from '@material-ui/core';
import {IGenericType} from 'constants/interfaces';
import {apiGETFARMPRODUCECONTRACTTYPES} from '../utils/graph';
type ContractTypeProps = {
  contractType?: IGenericType;
  includeFundingInfo?: boolean;
  onIncludeFundingInfo?: (value?: boolean) => void;
  onContractType?: (value?: IGenericType) => void;
};

const ContractType = (props: ContractTypeProps) => {
  const [contractType, setContractType] = useState<IGenericType | undefined>(
    props.contractType,
  );
  const [includeFundingInfo, setIncludeFundingInfo] = useState<
    boolean | undefined
  >(props.includeFundingInfo);
  const [contractTypes, setContractTypes] = useState<Array<IGenericType>>([]);

  useEffect(() => {
    apiGETFARMPRODUCECONTRACTTYPES().then((types) => {
      setContractTypes(types);
    });
  }, []);
  useEffect(() => {
    props.onIncludeFundingInfo?.(includeFundingInfo);
  }, [includeFundingInfo]);
  useEffect(() => {
    props.onContractType?.(contractType);
  }, [contractType]);
  const fundingInfo = useMemo(() => {
    if (includeFundingInfo === undefined) return undefined;
    return includeFundingInfo ? 'Yes' : 'No';
  }, [includeFundingInfo]);
  return (
    <div>
      <div className="title">Contract Type</div>
      <div className="row">
        <div className="col-6">
          <Typography>Contract Type</Typography>
        </div>
        <div className="col-6">
          <Select value={contractType?.id} fullWidth variant="outlined">
            {contractTypes.map((type) => (
              <MenuItem
                key={type.id}
                value={type.id}
                onClick={() => setContractType(type)}
              >
                {type.name}
              </MenuItem>
            ))}
          </Select>
        </div>
      </div>
      <div className="row">
        <div className="col-6">
          <Typography>Include funding info?</Typography>
        </div>
        <div className="col-6">
          <Select
            labelId="document-title-select-label"
            id="document-title-select"
            value={fundingInfo}
            onChange={(e) => setIncludeFundingInfo(e.target.value === 'Yes')}
            fullWidth
            type="select"
            variant="outlined"
          >
            {['Yes', 'No'].map((title) => (
              <MenuItem key={title} value={title}>
                {title}
              </MenuItem>
            ))}
          </Select>
        </div>
      </div>
    </div>
  );
};

export default ContractType;
